import { APIRoutesConfig } from '../../api-routes.config';

export class BaseHttpService {
  private _coApiUrl = '';
  private _reportApiUrl = '';
  private _cmApiUrl = '';
  private _fileApiUrl = '';
  private _powerBiApiUrl = '';
  private _addatechApiUrl = '';

  protected get reportApiUrl() {
    this._reportApiUrl = this._reportApiUrl || APIRoutesConfig.reportApiUrl;
    return this._reportApiUrl;
  }
  protected get coApiUrl() {
    this._coApiUrl = this._coApiUrl || APIRoutesConfig.coApiUrl;
    return this._coApiUrl;
  }
  protected get cmApiUrl() {
    this._cmApiUrl = this._cmApiUrl || APIRoutesConfig.cmApiUrl;
    return this._cmApiUrl;
  }
  protected get fileApiUrl() {
    this._fileApiUrl = this._fileApiUrl || APIRoutesConfig.fileApiUrl;
    return this._fileApiUrl;
  }
  protected get powerBiApiUrl() {
    this._powerBiApiUrl = this._powerBiApiUrl || APIRoutesConfig.powerBiApiUrl;
    return this._powerBiApiUrl;
  }
}
